export default __webpack_public_path__ + "static/media/6.ca01ecca.jpg";